import { PlusOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { FC } from "react";

type Props = {};

export const HeaderSupplies: FC<Props> = () => {
  return (
    <div className="flex justify-between items-center">
      <h2 className="text-2xl font-semibold">Supply & Materials Management</h2>
      <Space>
        <Button type="primary" icon={<PlusOutlined />}>
          New Order
        </Button>
        <Button icon={<UploadOutlined />}>Import Inventory</Button>
      </Space>
    </div>
  );
};
